import { useLang } from "@/context/LanguageContext";

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/15 bg-ink2 py-6">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-2xl italic text-sand/90 sm:text-3xl">{item}</span>
                <span className="mx-10 font-display text-sm text-gold">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
